import moment from 'moment';
class liquidation {
  constructor(
    liqId,
    liq,
    conceptoId,
    concepto,
    csCostoId,
    csCosto,
    cantLiq,
    cantAut,
    cantCC,
    cantNoAut) {
    this.liqId = liqId;
    this.liq = liq;
    this.conceptoId = conceptoId;
    this.concepto = concepto;
    this.csCostoId = csCostoId;
    this.csCosto = csCosto;
    this.cantLiq = this.formatCantidad(cantLiq);
    this.cantAut = this.formatCantidad(cantAut);
    this.cantCC = this.formatCantidad(cantCC);
    this.cantNoAut = this.formatCantidad(cantNoAut);  
  }

  static fromJson({
    liqId,
    liq,
    conceptoId,
    concepto,
    csCostoId,
    csCosto,
    cantLiq,
    cantAut,
    cantCC,
    cantNoAut
  }) {
    return new liquidation(
        liqId,
        liq,
        conceptoId,
        concepto,
        csCostoId,
        csCosto,
        cantLiq,
        cantAut,
        cantCC,
        cantNoAut
    );
  }
  formatCantidad(cantidad) {
    const horas = Math.floor(cantidad / 60);
    const minutos = cantidad % 60;
    return `${String(horas).padStart(2, "0")}:${String(minutos).padStart(2, "0")}`;
  }
}

export default liquidation;


  